import React from 'react'
import { Container, Button } from 'react-bootstrap'

const Newsletter = () => {
  return (
    <Container className='d-flex flex-column align-items-center pb-5'>
      <div className='d-flex flex-column align-items-center border-bottom border-dark p-4 my-5'>
        <h3>Subscribe to our newsletter</h3>
        <p>Culpa elit velit duis commodo est incididunt nostrud pariatur commodo Lorem sint fugiat culpa excepteur.</p>
      </div>
      <Button className='my-3 fs-4' variant='outline-dark p-3'>
        Subscribe
      </Button>
    </Container>

  )
}

export default Newsletter